import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Подпись раздела с уходящим в ничто лучом — приём с постеров Мезы.
 *
 * Нужен, чтобы у длинных экранов появилась иерархия: сейчас карточка
 * персонажа и разбор анкеты рисуют все четырнадцать полей одинаковыми
 * блоками подряд, и глазу не за что зацепиться.
 *
 * По умолчанию луч ФИОЛЕТОВЫЙ: в макетах он такой у двадцати четырёх подписей
 * из сорока трёх, то есть это обычный разделитель. Бирюзовый и малиновый —
 * исключения, и означают ровно то, что означает цвет в остальном приложении:
 * бирюза — принятое и живое, малиновый — то, где что-то решают или сносят.
 */
export function SectionTitle({
  children,
  count,
  badge,
  accent = 'violet',
}: {
  children: string;
  /**
   * Знак состояния всего раздела — и тогда луча НЕТ вовсе: в макете подпись
   * со знаком стоит парой внутри карточки, а луч отбивает только разделы
   * верхнего уровня. Оставленный рядом со знаком, он превращался в чёрточку
   * непонятного назначения между подписью и знаком.
   */
  badge?: ReactNode;
  /**
   * Сколько строк в разделе — через точку в самой подписи, как в макетах
   * («ПРЕДМЕТЫ · 7»). Отдельной строкой над списком счёт уезжал вместе с ним
   * при прокрутке, а подпись раздела остаётся видна.
   */
  count?: number | null;
  accent?: 'violet' | 'cyan' | 'pink';
}) {
  const text = count === undefined || count === null ? children : `${children} · ${count}`;

  return (
    <div className={styles.sectionTitle}>
      <span className={styles.sectionTitleText}>{text}</span>
      {badge === undefined ? (
        <span className={clsx(styles.sectionTitleRule, RULES[accent])} />
      ) : (
        badge
      )}
    </div>
  );
}

const RULES = {
  violet: styles.sectionTitleRuleViolet,
  cyan: styles.sectionTitleRuleCyan,
  pink: styles.sectionTitleRulePink,
};
